import React from "react";
import { Breadcrumb, Card, Col, Container, Row } from "react-bootstrap";
import About_Img from "../../Assets/images/About.png";
import { useNavigate } from "react-router-dom";
const About = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="main">
        <Container className="py-5 px-1">
          <Breadcrumb>
            <Breadcrumb.Item>
              <small
                className="BreadCrumbs_style"
                onClick={() => navigate("/")}
              >
                Home
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <small
                className="BreadCrumbs_style"
                onClick={() => navigate("/category/MicrosoftOffice")}
              >
                Shop
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
              <small className="BreadCrumbs_style">About Us</small>
            </Breadcrumb.Item>
          </Breadcrumb>

          <Container className="px-0">
            <Card className="Cart_Small_Card box_shadow">
              <Card.Body className="p-0">
                <Row>
                  <Col md={4} xl={4}>
                    <img src={About_Img} alt="AbouImg" className="About_Img" />
                  </Col>
                  <Col md={8} xl={8} className="About_Card_Para black_text p-5">
                    <h6>
                      <b>
                        Liberty Programs started with a demand for growth and
                        the need to upgrade our office software without spending
                        a small fortune. We were faced with the challenge of
                        being unable to find well-priced genuine software
                        products available on the online market.{" "}
                      </b>
                    </h6>
                    <p>
                      Realizing our ability to fulfill this market by having
                      formed strong relationships with authorized Microsoft
                      wholesalers, we made it our goal to be a trusted,
                      affordable, online American marketplace for software.
                      Liberty Programs is a small but growing company operating
                      out of New York City that moves at the same pace as the
                      big brands you know and count on.
                    </p>
                    <h6>
                      <b>
                        We offer software solutions for individuals and
                        corporations. Our speciality is software downloads
                        (delivered electronically) which are delivered to your
                        device quicker than a New York minute, thanks to our
                        dedicated team of sales & support staff!
                      </b>
                    </h6>
                    <p>
                      Liberty Programs work hand in hand with individuals,
                      corporations, government bodies, schools, and more! If you
                      don't find what you're looking for, we encourage you to
                      contact our team to help pinpoint the perfect selection.
                      Our team is trained to handle the most complex requests.
                      We look forward to your business for years to come!
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Container>
        </Container>
      </div>
    </>
  );
};

export default About;
